<template>
  <div class="ly-w1400">
    <section class="privacy-policy ly-wrap">
      <div class="privacy-policy-ttl">
        <h2 class="ly-cont">개인정보처리방침</h2>
        <div class="ly-cont">
          <div class="select_box">
            <div class="select">
              {{ selectedTitle }}
            </div>
            <ul class="list" @click="getSelected($event)">
              <li class="selected" v-for="item in privacyData" :key="item.id" :value="item.id">
                {{ item.title }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="ly-cont privacy-policy-txt" v-html="selectedContents"></div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      selectedTitle: null,
      selectedContents: null,
    };
  },

  computed: {
    ...mapState({
      privacyData: (state) => state.others.privacy,
    }),
  },

  created() {
    const self = this;

    self.selectedTitle = self.privacyData[0].title;
    self.selectedContents = self.privacyData[0].contents;
  },

  mounted() {
    let selectBox = document.querySelector(".select_box");
    selectBox.addEventListener("click", function () {
      selectBox.classList.toggle("on");
    });
  },

  methods: {
    getSelected(click) {
      const self = this;

      if (click.target.tagName == "LI") {
        let selectedId = click.target.value;

        let selectedData = self.privacyData.filter((item) => {
          let filtered = true;
          filtered = item.id == selectedId;
          return filtered;
        });

        self.selectedTitle = selectedData[0].title;
        self.selectedContents = selectedData[0].contents;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/helpers/variables";
@import "~@/assets/scss/helpers/mixins";
@import "~@/assets/scss/base/typhography";

.privacy-policy {
  .privacy-policy-ttl {
    border-bottom: 1px solid $color-black;
    height: 370px;
    h2 {
      padding-top: 129px;
      font-size: 40px;
      font-weight: bold;
      letter-spacing: -1.2px;
    }
    .ly-cont * {
      margin: 0;
      padding: 0;
    }
    .ly-cont ul li,
    .ly-cont ol li {
      list-style: none;
    }
    .select_box {
      margin: 20px 0px;
      display: inline-block;
      position: relative;
    }
    .select_box .select {
      position: relative;
      box-sizing: border-box;
      height: 40px;
      line-height: 35px;
      font-size: 16px;
      background-color: #fff;
      align-content: center;
      margin: 80px 0 0;
      margin-left: 0px;
      width: 500px;
      padding: 8px 10px;
      height: auto;
      font-family: inherit;
      border: 1px solid #222;
      border-radius: 0px;
      cursor: pointer;
    }
    .select_box.on .select {
      border-bottom: 0px solid #222;
    }
    .select_box .select:after {
      content: url("https://img.davich.com/image/sub/icon-arrow-down.png");
      position: absolute;
      top: 8px;
      right: 10px;
    }
    .select_box.on .select:after {
      content: url("https://img.davich.com/image/sub/about/icon-arrow-up.png");
      align-content: center;
    }
    .select_box .list {
      display: none;
      overflow-y: auto;
      position: relative;
      left: 0;
      z-index: 10;
      border: 1px solid #222;
      border-top: 0px solid #222;
      box-sizing: border-box;
      width: 500px;
      background-color: #fff;
    }
    .select_box.on .list {
      display: block;
    }

    .select_box .list > li {
      box-sizing: border-box;
      padding: 8px 10px;
      width: 100%;
      line-height: 35px;
      cursor: pointer;
    }
    .select_box .list > li:hover {
      background-color: #f0f8ff;
    }
  }
  .privacy-policy-txt {
    padding: 70px 0 200px 0;
    line-height: 24px;
  }
}
</style>
